<h2 class="title">
    REVISTA
</h2>